import { ResponsiveContainer, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip } from "recharts";
import { CHART_DATA } from "@/lib/content";

export const BistChart = () => (
  <div className="h-[220px] w-full" data-testid="bist-chart">
    <ResponsiveContainer width="100%" height="100%">
      <AreaChart data={CHART_DATA} margin={{ top: 10, right: 8, left: -18, bottom: 0 }}>
        <defs>
          <linearGradient id="bistArea" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#22c55e" stopOpacity={0.5} />
            <stop offset="100%" stopColor="#22c55e" stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.08)" vertical={false} />
        <XAxis dataKey="year" tick={{ fill: "rgba(255,255,255,0.55)", fontSize: 11 }} axisLine={false} tickLine={false} />
        <YAxis tick={{ fill: "rgba(255,255,255,0.45)", fontSize: 10 }} axisLine={false} tickLine={false} domain={[2000, 8000]} ticks={[2000, 4000, 6000, 8000]} />
        <Tooltip
          contentStyle={{ background: "#0a1a33", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 12, color: "#fff" }}
          labelStyle={{ color: "#4b86dd" }}
          formatter={(v) => [v, "BIST 100"]}
        />
        <Area type="monotone" dataKey="v" stroke="#22c55e" strokeWidth={2.5} fill="url(#bistArea)" />
      </AreaChart>
    </ResponsiveContainer>
  </div>
);
